const ldk4Main = (() => {
  const page4ldk = (document.getElementById("page4ldk") != null);
  if (page4ldk) {



    let secMain = document.querySelector("#jsSecMain")
    let img = secMain.querySelector(".js-img")
    let secIntro = document.querySelector("#jsSecIntro")
    let ttl = secIntro.querySelector(".js-ttl")
    let subttl = secIntro.querySelector(".js-subttl")


    setTimeout(() => {
      img.classList.add('act');
    }, 100);
    setTimeout(() => {
      ttl.classList.add('act');
    }, 1000);
    setTimeout(() => {
      subttl.classList.add('act');
    }, 1500);



  }
})()
export default ldk4Main;